import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import Layout from "../../layouts/layout"
import GalleryCard, { GalleryCardView } from "../../components/gallery-card/galleryCard"

import edit from "../../assets/icons/generals/Edit.svg"
import deleteIcon from "../../assets/icons/generals/delete-2.svg"
import { useEffect, useState } from "react"
import AddPictureCard from "../../components/gallery-card/addPictureCard"
import { useRequestProcessor } from "../../api/requestProcessor"
import { deleteSingleGallery, getSingleGallery, updateSingleGalleries } from "../../api/galleries"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { confirmAlert } from "react-confirm-alert"

const ViewGallery = () => {

    const [title, setTitle] = useState("")
    const [newGallery, setNewGallery] = useState([])
    const [isEditable, setIsEditable] = useState(false)


    const navigate = useNavigate()
    const { gallery_id } = useParams()

    const { Query, Mutate } = useRequestProcessor();

    const { data, refetch, isError } = Query(
        ['getSingleGallery',],
        () => getSingleGallery(gallery_id),
    );

    const { mutate: mutateGallery } = Mutate(
        ["updateGallery", data?.data?.id],
        updateSingleGalleries,
        {
            onSuccess: (data) => {
                toast.success(data.message + " تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید.", {
                    autoClose: 2500,
                    progress: false,
                })
                setTimeout(() => navigate("/admin/galleries"), 3000)
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );

    useEffect(() => {
        setTitle(data?.data?.title)
    }, [data])

    function onAddImage(imageData) {
        setNewGallery(prev => [...prev, imageData])
    }

    function handleRefetch() {
        refetch()
    }

    function handleSubmitGallery(e) {
        e.preventDefault();
        mutateGallery({ id: data?.data?.id, data: { title: title, gallery_images: newGallery } })
    }

    function handleFilterNewImage(index) {
        setNewGallery(prev => prev.splice(index, 1))
    }
    
    const { mutate: deleteMutate  } = Mutate(
        "deleteDiscount",
        deleteSingleGallery,
        {
            onSuccess: (data) => {
                toast.success(data.message)//This is the response you get back
                navigate("/admin/galleries")
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );



    async function onDeleteHandler() {
        confirmAlert({
        overlayClassName: "modalBackDrop-bg",
        customUI: ({ onClose }) => {
            return (
                <div className='bg-white wsm:w-full w-[750px] py-8 px-4 rounded-xl font-bold'>
                    <h1 className=" text-center pb-4">
                        {"آیا از حذف گالری " + title + " مطمعن هستید؟"}
                    </h1>
                    <div className="flex justify-around ">

                        <button className="" onClick={onClose}>خیر</button>
                        <button className="border-2 text-red-500 rounded-lg py-3 !px-5 border-red-500"
                            onClick={() => {deleteMutate(gallery_id);onClose()}}>
                            بله
                        </button>
                    </div>
                </div>
            );
        }
    })
}
    return (
        <Layout>
            <MainPageLayout backButton sectionTitle={"ویرایش گالری " + title + " :"} title={"ویرایش گالری"}>
                <form onSubmit={handleSubmitGallery} className="flex flex-col">
                    <div className="flex items-center justify-between mb-8 ">
                        <div className="flex items-center">
                            {
                                isEditable ?
                                    <input type="text" className="form-input !w-full" onChange={e => setTitle(e.target.value)} placeholder={title} />
                                    :
                                    <p className="text-2xl font-bold">
                                        {title}
                                    </p>
                            }
                            <div className="px-5 cursor-pointer">
                                <img src={edit} alt="ویرایش" onClick={() => setIsEditable(prev => !prev)} />
                            </div>
                        </div>
                        <div className="flex">
                            <div className=" cursor-pointer" onClick={()=>onDeleteHandler()}>
                                <img src={deleteIcon} className="w-6" alt="حذف گالری" />
                            </div>
                        </div>
                    </div>
                    <div className="!grid !grid-cols-4 !gap-y-8 !gap-x-6 min-h-full wsm:!grid-cols-2">
                        {
                            data?.data?.file?.map((el) => (
                                <GalleryCardView id={el.id} handleRefetch={handleRefetch} imageSrc={el.file?.thumb} />
                            ))
                        }
                        {
                            newGallery.map((el, index) => (
                                <GalleryCardView id={index} isNewGallery filterNewImage={handleFilterNewImage} handleRefetch={handleRefetch} imageSrc={el.thumb} />
                            ))
                        }
                        <AddPictureCard onAddImage={onAddImage} />
                    </div>

                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout >
    )
}

export default ViewGallery